export const SchoolingStatusEnum = {
  Sim: 'Sim',
  Nao: 'Não',
  InProgress: 'Em curso',
};
